/**
 * Shipping ETA Widget - Clean Version
 * Simplified for conditional HTML rendering
 */

(function () {
  "use strict";

  // ---- CONFIGURATION: Full countries mapping
  // Priority countries first (US, GB, AU, CA), then alphabetically sorted by country name
  const COUNTRIES = {
    US: "United States",
    GB: "United Kingdom",
    AU: "Australia",
    CA: "Canada",
    AF: "Afghanistan",
    AL: "Albania",
    DZ: "Algeria",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AG: "Antigua Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AC: "Ascension Island",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia & Herzegovina",
    BW: "Botswana",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    VG: "British Virgin Islands",
    BN: "Brunei",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CV: "Cape Verde",
    BQ: "Caribbean Netherlands",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo - Brazzaville",
    CD: "Congo - Kinshasa",
    CK: "Cook Islands",
    CR: "Costa Rica",
    HR: "Croatia",
    CW: "Curaçao",
    CY: "Cyprus",
    CZ: "Czechia",
    CI: "Côte d'Ivoire",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    SZ: "Eswatini",
    ET: "Ethiopia",
    FK: "Falkland Islands",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HN: "Honduras",
    HK: "Hong Kong SAR",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    XK: "Kosovo",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Laos",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao SAR",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar (Burma)",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MK: "North Macedonia",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PS: "Palestinian Territories",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn Islands",
    PL: "Poland",
    PT: "Portugal",
    QA: "Qatar",
    RO: "Romania",
    RU: "Russia",
    RW: "Rwanda",
    RE: "Réunion",
    WS: "Samoa",
    SM: "San Marino",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SX: "Sint Maarten",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia & South Sandwich Islands",
    KR: "South Korea",
    SS: "South Sudan",
    ES: "Spain",
    LK: "Sri Lanka",
    BL: "St. Barthélemy",
    SH: "St. Helena",
    KN: "St. Kitts & Nevis",
    LC: "St. Lucia",
    MF: "St. Martin",
    PM: "St. Pierre & Miquelon",
    VC: "St. Vincent & Grenadines",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard & Jan Mayen",
    SE: "Sweden",
    CH: "Switzerland",
    ST: "São Tomé & Príncipe",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad & Tobago",
    TA: "Tristan da Cunha",
    TN: "Tunisia",
    TM: "Turkmenistan",
    TC: "Turks & Caicos Islands",
    TV: "Tuvalu",
    TR: "Türkiye",
    UM: "U.S. Outlying Islands",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VA: "Vatican City",
    VE: "Venezuela",
    VN: "Vietnam",
    WF: "Wallis & Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    AX: "Åland Islands",
  };

  // ---- Utility Functions
  // Resolve this script's own widget instance rather than looking elements
  // up by a fixed global id. This snippet's ids are namespaced per section
  // (see shipping-eta.liquid), but a page can still contain more than one
  // rendered copy at once (e.g. the quick-add modal fetches and injects a
  // whole extra <product-info>), so lookups stay scoped to the container
  // this exact <script> tag lives in instead of assuming a single instance.
  const currentScript = document.currentScript;
  const root =
    currentScript?.closest(".eta-widget") ||
    Array.from(document.querySelectorAll(".eta-widget")).pop() ||
    null;

  const $ = (selector) => (root ? root.querySelector(selector) : null);

  const safeNow = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const addDays = (d, n) => {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
  };

  const fmt = (d) =>
    d.toLocaleString("en-US", { month: "short", day: "numeric" });

  const fmtRange = (d1, d2) => {
    const m1 = d1.toLocaleString("en-US", { month: "short" });
    const m2 = d2.toLocaleString("en-US", { month: "short" });
    return m1 === m2
      ? `${m1} ${d1.getDate()} - ${d2.getDate()}`
      : `${m1} ${d1.getDate()} - ${m2} ${d2.getDate()}`;
  };

  const normCC = (cc) => (cc === "UK" ? "GB" : cc);

  // Debounced localStorage operations
  // Keyed by the storage key so saving "area_deliver" and "eta_method_idx"
  // in the same tick doesn't cancel each other's pending write.
  function debounceByKey(fn, wait = 150) {
    const timers = new Map();
    return (key, ...args) => {
      clearTimeout(timers.get(key));
      timers.set(
        key,
        setTimeout(() => fn(key, ...args), wait)
      );
    };
  }

  const saveLS = debounceByKey((key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn("[ETA] localStorage save failed:", e);
    }
  });

  // ---- Safe Rich Text Renderer (JSON to DOM)
  function appendText(parent, text) {
    parent.appendChild(document.createTextNode(String(text || "")));
  }

  function isHttpUrl(url) {
    try {
      const parsed = new URL(url, location.origin);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch {
      return false;
    }
  }

  function renderRichTextNode(node, parent) {
    if (!node) return;
    if (Array.isArray(node)) {
      node.forEach((n) => renderRichTextNode(n, parent));
      return;
    }

    const { type, children } = node;

    switch (type) {
      case "root":
        renderRichTextNode(children || [], parent);
        break;

      case "paragraph":
        const p = document.createElement("p");
        parent.appendChild(p);
        renderRichTextNode(children || [], p);
        break;

      case "list":
        const listTag = node.listType === "ordered" ? "ol" : "ul";
        const list = document.createElement(listTag);
        parent.appendChild(list);
        renderRichTextNode(children || [], list);
        break;

      case "list-item":
        const li = document.createElement("li");
        parent.appendChild(li);
        renderRichTextNode(children || [], li);
        break;

      case "link":
        const a = document.createElement("a");
        const href = node.url || "#";
        a.rel = "noopener noreferrer";
        a.target = "_blank";
        if (isHttpUrl(href)) {
          a.href = href;
        }
        parent.appendChild(a);
        renderRichTextNode(children || [], a);
        break;

      case "text":
        let text = String(node.value || "");
        if (node.bold) {
          const strong = document.createElement("strong");
          appendText(strong, text);
          parent.appendChild(strong);
        } else if (node.italic) {
          const em = document.createElement("em");
          appendText(em, text);
          parent.appendChild(em);
        } else if (node.underline) {
          const u = document.createElement("u");
          appendText(u, text);
          parent.appendChild(u);
        } else {
          appendText(parent, text);
        }
        break;

      default:
        // Fallback: try to render children
        renderRichTextNode(children || [], parent);
    }
  }

  function renderRichTextTo(container, tree) {
    if (!container) return;
    container.innerHTML = ""; // Safe since we control this container

    try {
      // Limit rendering to prevent DOM bloat
      const maxNodes = 100;

      const countNodes = (node) => {
        if (!node) return 0;
        if (Array.isArray(node))
          return node.reduce((sum, n) => sum + countNodes(n), 0);
        return 1 + countNodes(node.children);
      };

      if (countNodes(tree) > maxNodes) {
        console.warn("[ETA] Rich text too complex, truncating");
        container.textContent = "Content too large to display";
        return;
      }

      renderRichTextNode(tree, container);
    } catch (e) {
      console.error("[ETA] Rich text render error:", e);
      container.textContent = "Error displaying content";
    }
  }

  // ---- Parse Data JSON Safely
  let data = { profiles: [], has_many: false };
  try {
    const dataElement = $("script.eta-data");
    if (dataElement) {
      const rawData = dataElement.textContent || "{}";
      data = JSON.parse(rawData);
      if (!Array.isArray(data.profiles)) {
        data.profiles = [];
      }
    }
  } catch (e) {
    console.error("[ETA] JSON parse error:", e);
    data = { profiles: [], has_many: false };
  }

  // ---- Get DOM Elements
  // The skeleton box is a previous sibling of the widget root, not a
  // descendant, so it can't be found via the same scoped `$` query.
  const skeletonSibling = root?.previousElementSibling || null;

  const elements = {
    root,
    selCountry: $(".eta-country"),
    selMethod: $(".eta-method-select"),
    methodLabel: $(".eta-method-label"), // The "Method:" text next to the select
    // Matches whichever single-method label is present: the Liquid-static
    // one (total == 1) or the collapsed-dropdown one (total > 1 but only
    // one method is actually available for the selected country).
    shippingLabel: $(".eta-label"),
    dateRange: $(".eta-date-underline"),
    orderDate: $(".eta-order-date"),
    shipRange: $(".eta-ship-range"),
    delivRange: $(".eta-delivery-range"),
    noteUser: $(".eta-note-user"),
    noteDefault: $(".eta-notes-default"),
    hoverWrap: $(".eta-getitby"),
    popover: $(".eta-popover"),
    skeleton:
      skeletonSibling && skeletonSibling.classList.contains("ctm-skeleton-box")
        ? skeletonSibling
        : null,
  };

  // Validate required elements
  if (!elements.root || !elements.selCountry || !elements.dateRange) {
    console.warn("[ETA] Missing required DOM elements");
    return;
  }

  // ---- Setup Accessibility
  function setupAccessibility() {
    elements.selCountry.setAttribute(
      "aria-label",
      "Select shipping destination country"
    );
    elements.dateRange.setAttribute("aria-live", "polite");

    if (elements.selMethod) {
      elements.selMethod.setAttribute("aria-label", "Select shipping method");
    }

    if (elements.popover) {
      elements.popover.setAttribute("role", "dialog");
      elements.popover.setAttribute("aria-modal", "false");
    }

    if (elements.hoverWrap) {
      elements.hoverWrap.setAttribute("role", "button");
      elements.hoverWrap.setAttribute("tabindex", "0");
      elements.hoverWrap.setAttribute("aria-expanded", "false");
      if (elements.popover) {
        elements.hoverWrap.setAttribute("aria-controls", elements.popover.id);
      }
    }
  }

  // ---- Build Select Options
  // Cache country entries to avoid repeated Object.entries calls
  const countryEntries = Object.entries(COUNTRIES);

  function buildSelects() {
    try {
      // Use cached country entries
      countryEntries.forEach(([code, name]) => {
        const option = document.createElement("option");
        option.value = code;
        option.textContent = name;
        elements.selCountry.appendChild(option);
      });

      // Populate method select will be done dynamically in updateMethodOptions()
    } catch (e) {
      console.error("[ETA] Build selects error:", e);
    }
  }

  // ---- Update Method Options Based on Country
  function updateMethodOptions(countryCode) {
    if (!elements.selMethod) return;

    try {
      // Clear cache when country changes
      clearProfileCache();

      // Store current selection to try to restore it
      const currentSelection = elements.selMethod.value;
      elements.selMethod.innerHTML = "";

      // Get available profiles (cached)
      const availableProfiles = getAvailableProfiles(countryCode);

      // Show only available profiles, deduped by label. Two profiles can
      // legitimately share the same displayed name for different country
      // scopes (e.g. "Standard Shipping" split into a US profile and an
      // AU/GB profile) -- the shopper should never see the same method
      // name twice in the list, even if both happen to resolve as
      // available for the same country.
      const seenLabels = new Set();
      availableProfiles.forEach(({ profile, index }) => {
        const label = profile.label || `Method ${index + 1}`;
        if (seenLabels.has(label)) return;
        seenLabels.add(label);

        const option = document.createElement("option");
        option.value = String(index);
        option.textContent = label;
        elements.selMethod.appendChild(option);
      });

      // Try to restore previous selection if valid
      let targetIndex = null;

      if (currentSelection !== "" && currentSelection != null) {
        // Try to restore previous selection if it's still available
        const currentIndex = Number(currentSelection);
        const isCurrentAvailable = availableProfiles.some(
          (ap) => ap.index === currentIndex
        );

        if (isCurrentAvailable) {
          targetIndex = currentIndex;
        }
      }

      // If no valid selection, use first available profile
      if (targetIndex === null && availableProfiles.length > 0) {
        targetIndex = availableProfiles[0].index;
      }

      // Set the select value
      if (targetIndex !== null) {
        elements.selMethod.value = String(targetIndex);
      }

      // Collapse the dropdown down to a plain label when the selected
      // country only ever resolves to one distinct *named* method.
      // Liquid decides "show a select" purely from the product's total
      // profile count, without knowing the shopper's country yet, so a
      // product with e.g. a US profile and an AU/GB-only profile still
      // renders a <select> here even though any single country only ever
      // has one of them available. Dedupe by label rather than by raw
      // profile count: two profiles can share the same displayed name
      // (e.g. both called "Standard Shipping", split by country) and
      // should still read as a single method to the shopper even if
      // they happen to both resolve as "available" for the same country
      // (e.g. the merchant forgot to set exclude_countries on one side).
      // Reuses seenLabels, built above while populating the (deduped)
      // <option> list, so the collapse decision always matches what's
      // actually in the dropdown.
      const showDropdown = seenLabels.size > 1;
      elements.selMethod.style.display = showDropdown ? "" : "none";
      if (elements.methodLabel) {
        elements.methodLabel.style.display = showDropdown ? "" : "none";
      }
      if (elements.shippingLabel) {
        elements.shippingLabel.style.display = showDropdown ? "none" : "";
      }
    } catch (e) {
      console.error("[ETA] Update method options error:", e);
    }
  }

  // ---- Helper Functions
  function coerceCountryList(value) {
    if (Array.isArray(value)) {
      return value.map((s) => String(s).trim().toUpperCase()).filter(Boolean);
    }
    if (typeof value === "string") {
      return value
        .split(",")
        .map((s) => s.trim().toUpperCase())
        .filter(Boolean);
    }
    return [];
  }

  // Validate profile data structure
  function validateProfile(profile) {
    if (!profile || typeof profile !== "object") return false;

    const requiredFields = [
      "production_primary",
      "production_other",
      "shipping_primary",
      "shipping_other",
    ];
    return requiredFields.every(
      (field) => Array.isArray(profile[field]) && profile[field].length === 2
    );
  }

  // Cache for available profiles per country to avoid repeated filtering
  const availableProfilesCache = new Map();

  function getAvailableProfiles(countryCode) {
    if (availableProfilesCache.has(countryCode)) {
      return availableProfilesCache.get(countryCode);
    }

    const available = data.profiles
      .map((profile, index) => ({ profile, index }))
      .filter(({ profile }) => isProfileAvailable(profile, countryCode));

    availableProfilesCache.set(countryCode, available);
    return available;
  }

  // Clear cache when country changes
  function clearProfileCache() {
    availableProfilesCache.clear();
  }

  function isInPrimaryCountries(profile, countryCode) {
    const countryCodes = coerceCountryList(profile.country_codes);
    return countryCodes.includes(normCC(countryCode));
  }

  function isProfileAvailable(profile, countryCode) {
    if (!validateProfile(profile)) return false;

    // First check if country is excluded
    const excludeCodes = coerceCountryList(profile.exclude_countries);
    if (excludeCodes.includes(normCC(countryCode))) {
      return false;
    }

    const usePrimary = isInPrimaryCountries(profile, countryCode);
    const production = usePrimary
      ? profile.production_primary
      : profile.production_other;

    return production[0] > 0 && production[1] > 0;
  }

  function computeShippingData(profile, countryCode) {
    const today = safeNow();
    const usePrimary = isInPrimaryCountries(profile, countryCode);

    const production = usePrimary
      ? profile.production_primary
      : profile.production_other;
    const shipping = usePrimary
      ? profile.shipping_primary
      : profile.shipping_other;

    const [prodMin, prodMax] = production.map(Number);
    const [shipMin, shipMax] = shipping.map(Number);

    const totalMin = prodMin + shipMin;
    const totalMax = prodMax + shipMax;

    return {
      label: profile.label || "Shipping",
      orderPlaced: fmt(today),
      shipWindow:
        prodMin === prodMax
          ? fmt(addDays(today, prodMin))
          : fmtRange(addDays(today, prodMin), addDays(today, prodMax)),
      delivered:
        totalMin === totalMax
          ? fmt(addDays(today, totalMin))
          : fmtRange(addDays(today, totalMin), addDays(today, totalMax)),
    };
  }

  // ---- Initialize State
  function initializeState() {
    const defaultCC = elements.root.dataset.defaultCountry || "US";
    let savedCC;

    try {
      savedCC = localStorage.getItem("area_deliver");
    } catch {
      savedCC = null;
    }

    const initialCC =
      savedCC && COUNTRIES[savedCC]
        ? savedCC
        : COUNTRIES[defaultCC]
        ? defaultCC
        : "US";

    elements.selCountry.value = initialCC;

    // Update method options for initial country (first option auto-selected)
    updateMethodOptions(initialCC);

    // Restore method selection from localStorage if available
    if (elements.selMethod) {
      let savedMethod;
      try {
        savedMethod = localStorage.getItem("eta_method_idx");
      } catch {
        savedMethod = null;
      }

      if (savedMethod && Number(savedMethod) < data.profiles.length) {
        const savedProfile = data.profiles[Number(savedMethod)];
        if (savedProfile && isProfileAvailable(savedProfile, initialCC)) {
          elements.selMethod.value = savedMethod;
        }
      }
    }
  }

  // Clear every displayed field to a neutral "unavailable" state. Used when
  // no shipping profile matches the selected country, so the label/timeline
  // don't keep showing stale data from the previous country.
  function resetShippingDisplay() {
    elements.dateRange.textContent = "—";
    if (elements.shippingLabel) {
      elements.shippingLabel.textContent = "Not available";
    }
    if (elements.orderDate) elements.orderDate.textContent = "—";
    if (elements.shipRange) elements.shipRange.textContent = "—";
    if (elements.delivRange) elements.delivRange.textContent = "—";
    if (elements.noteUser) {
      elements.noteUser.hidden = true;
      elements.noteUser.textContent = "";
    }
    if (elements.noteDefault) {
      elements.noteDefault.style.display = "";
    }
  }

  // ---- Main Render Function
  function render(skipMethodUpdate = false) {
    let countryCode = elements.selCountry.value || "US";

    // Validate country code
    if (!COUNTRIES[countryCode]) {
      console.warn(
        "[ETA] Invalid country code:",
        countryCode,
        "falling back to US"
      );
      countryCode = "US";
      elements.selCountry.value = "US";
    }

    // Update method options for current country (skip if already updated in initializeState)
    if (!skipMethodUpdate) {
      updateMethodOptions(countryCode);
    }

    // Check if any profiles are available for current country (cached)
    const availableProfiles = getAvailableProfiles(countryCode);

    if (!availableProfiles.length) {
      console.warn(
        "[ETA] No shipping profiles available for country:",
        countryCode
      );
      resetShippingDisplay();
      return;
    }

    let methodIndex = elements.selMethod
      ? Number(elements.selMethod.value || 0)
      : 0;

    // Ensure method index is within bounds and profile is available
    methodIndex = Math.max(0, Math.min(methodIndex, data.profiles.length - 1));
    const profile = data.profiles[methodIndex];

    // If selected profile is not available, use first available
    if (!profile || !isProfileAvailable(profile, countryCode)) {
      methodIndex =
        availableProfiles.length > 0 ? availableProfiles[0].index : 0;
    }

    const finalProfile = data.profiles[methodIndex];

    try {
      const result = computeShippingData(finalProfile, countryCode);

      // Update shipping label only if it exists (single method case)
      if (elements.shippingLabel) {
        elements.shippingLabel.textContent = result.label;
      }

      // Always update date range
      elements.dateRange.textContent = result.delivered;

      if (elements.orderDate) {
        elements.orderDate.textContent = result.orderPlaced;
      }
      if (elements.shipRange) {
        elements.shipRange.textContent = result.shipWindow;
      }
      if (elements.delivRange) {
        elements.delivRange.textContent = result.delivered;
      }

      // Handle rich text notes
      if (elements.noteUser) {
        const noteTree = finalProfile.note_html;
        const hasContent =
          noteTree && (!Array.isArray(noteTree) || noteTree.length > 0);

        elements.noteUser.hidden = !hasContent;
        if (elements.noteDefault) {
          elements.noteDefault.style.display = hasContent ? "none" : "";
        }

        if (hasContent) {
          renderRichTextTo(elements.noteUser, noteTree);
        }
      }

      // Save selections (debounced)
      saveLS("area_deliver", countryCode);
      if (elements.selMethod) {
        saveLS("eta_method_idx", String(methodIndex));
      }
    } catch (e) {
      console.error("[ETA] Render error:", e);
      elements.root.classList.add("error");
    }
  }

  // ---- Popover Management
  function setPopoverState(isOpen) {
    if (elements.hoverWrap) {
      elements.hoverWrap.classList.toggle("open", isOpen);
      elements.hoverWrap.setAttribute("aria-expanded", String(isOpen));
    }
    if (elements.popover) {
      elements.popover.setAttribute("aria-hidden", String(!isOpen));
    }
  }

  const closePopover = () => setPopoverState(false);
  const togglePopover = () =>
    setPopoverState(!elements.hoverWrap?.classList.contains("open"));

  // ---- Event Listeners
  let documentClickHandler = null;

  function setupEventListeners() {
    // Country selection change with proper method update
    elements.selCountry.addEventListener("change", () => {
      const newCountry = elements.selCountry.value;
      updateMethodOptions(newCountry);
      render(true); // Skip method update since we just did it
    });

    // Method selection change
    if (elements.selMethod) {
      elements.selMethod.addEventListener("change", render);
    }

    // Popover interactions
    if (elements.hoverWrap) {
      // Click to toggle
      elements.hoverWrap.addEventListener("click", (e) => {
        e.stopPropagation();
        togglePopover();
      });

      // Keyboard navigation
      elements.hoverWrap.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          togglePopover();
        }
        if (e.key === "Escape") {
          closePopover();
        }
      });
    }

    // Close popover when clicking outside - store reference for cleanup
    documentClickHandler = (e) => {
      if (elements.hoverWrap && !elements.hoverWrap.contains(e.target)) {
        closePopover();
      }
    };
    document.addEventListener("click", documentClickHandler);
  }

  // Cleanup function for event listeners
  function cleanup() {
    if (documentClickHandler) {
      document.removeEventListener("click", documentClickHandler);
      documentClickHandler = null;
    }
    // Clear caches on cleanup
    clearProfileCache();
  }

  // ---- Initialize Everything
  function init() {
    try {
      setupAccessibility();
      buildSelects();
      initializeState();
      setupEventListeners();
      render(true); // Skip method update since it was done in initializeState
      setTimeout(() => {
        if (elements.skeleton) {
          elements.skeleton.classList.add("loaded");
        }
      }, 100);
    } catch (e) {
      console.error("[ETA] Initialization failed:", e);
      if (elements.root) {
        elements.root.classList.add("error");
      }
    }
  }

  // Tear down any previous instance of this widget before wiring up this
  // one. This script can re-execute on the same page (e.g. Dawn's
  // HTMLUpdateUtility re-injects <script> tags when product-info is swapped
  // on variant/product changes), and without this the old instance's
  // document-level click listener is never removed.
  if (typeof window.etaWidgetCleanup === "function") {
    window.etaWidgetCleanup();
  }

  // Expose cleanup function globally for external cleanup if needed
  window.etaWidgetCleanup = cleanup;

  // Start when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
